import { useEffect, useState } from "react";
import { APP_VERSION } from "../version";

const CHECK_INTERVAL_MS = 5 * 60 * 1000;

export function useVersionCheck() {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const res = await fetch(
          `${process.env.PUBLIC_URL}/version.json?_=${Date.now()}`,
          { cache: "no-store" }
        );
        if (!res.ok) return;
        const { version } = await res.json();
        if (!cancelled && version && version !== APP_VERSION) {
          setNewVersionAvailable(true);
        }
      } catch {
        // Offline / DNS / CDN blip — try again next tick.
      }
    };

    check();
    const interval = setInterval(check, CHECK_INTERVAL_MS);
    const onFocus = () => check();
    window.addEventListener("focus", onFocus);

    return () => {
      cancelled = true;
      clearInterval(interval);
      window.removeEventListener("focus", onFocus);
    };
  }, []);

  return newVersionAvailable;
}
